import {
  Component,
  ViewChild,
  ContentChild,
  HostListener,
  ElementRef,
  AfterViewChecked,
  Renderer2,
  AfterContentInit,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatTable } from "@angular/material/table";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
// import { PermissionTreeConfig } from '@;

@Component({
  selector: "up-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TableComponent implements AfterViewChecked, AfterContentInit {
  //# People
  @Input() heightAuto: boolean = false;
  @Input() showAbsenceImport: boolean = false;
  @Input() columns!: string[];
  @Input() index?: number;

  @Output() addClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() importClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() previousClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();
  //#endregion

  @Output() addClickedSoftwares: EventEmitter<any> = new EventEmitter<any>();

  @Input() accessGroupId: number = 0;

  @Input() permission?: any;

  @Input() offset?: number = 324;
  @Input() showFilter: boolean = true;
  @Input() showAddButton: boolean = false;
  @Input() showPaginator: boolean = true;

  @ViewChild("paginator", { static: false }) paginator!: MatPaginator;
  @ViewChild("mainContent", { static: false }) mainContent?: ElementRef;

  @ContentChild(MatTable) table!: MatTable<any>;
  @ContentChild(MatSort) sort!: MatSort;

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.renderHeight(event.target.innerHeight);
  }

  constructor(private _renderer: Renderer2) {}

  ngAfterContentInit(): void {
    let interval = setInterval(() => {
      if (this.table.dataSource) {
        if (this.columns)
          //# People
          (<MatTableDataSource<any>>this.table.dataSource).filterPredicate = (
            data,
            filter,
          ) => {
            // Transform the data into a lowercase string of all property values.
            let dataStr: string = "";

            for (const key of Object.keys(data)) {
              // Verificar se está pegando o valor de algumas das colunas que é exibida
              if (this.columns.indexOf(key) > -1) {
                // Use an obscure Unicode character to delimit the words in the concatenated string.
                // This avoids matches where the values of two columns combined will match the user's query
                // (e.g. `Flute` and `Stop` will match `Test`). The character is intended to be something
                // that has a very low chance of being typed in by somebody in a text field. This one in
                // particular is "White up-pointing triangle with dot" from
                // https://en.wikipedia.org/wiki/List_of_Unicode_characters

                // Transformar objetos complexos em json para facilitar a pesquisa
                if (
                  typeof data[key] === "object" &&
                  !Array.isArray(data[key]) &&
                  data[key] !== null
                ) {
                  dataStr += JSON.stringify(data[key]).replace('"', "") + "◬";
                }

                dataStr += data[key] + "◬";
              }
            }

            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter
              .trim()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
            return (
              dataStr
                .trim()
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .indexOf(transformedFilter) != -1
            );
          };
        //#endregion

        (<MatTableDataSource<any>>this.table.dataSource).sort = this.sort;
        (<MatTableDataSource<any>>this.table.dataSource).paginator =
          this.paginator;
        clearInterval(interval);
      }
    }, 500);
  }

  ngAfterViewChecked(): void {
    this.renderHeight(window.innerHeight);
  }

  renderHeight(height: number) {
    if (!!this.mainContent)
      this._renderer.setStyle(
        this.mainContent.nativeElement,
        "height",
        height - this.offset! + "px",
      );
  }

  applyFilter(filterValue: any) {
    let result = (filterValue as HTMLInputElement).value;

    if (this.table?.dataSource) {
      (<MatTableDataSource<any>>this.table.dataSource).filter = result
        .trim()
        .toLowerCase();
    }

    this.filterChange.emit(result.trim().toLowerCase());
  }

  addClick() {
    this.addClicked.emit();
  }

  addClickSoftware() {
    this.addClickedSoftwares.emit();
  }

  importClicked(): void {
    this.importClick.emit();
  }

  onPage(): void {
    if (!!this.mainContent) this.mainContent.nativeElement.scrollTop = 0;
  }
}
